import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProfileFetch } from '../redux/actions/user.action'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import SignupVerifyPage from './SignupVerifyPage'
import ChangePassword from './ChangePassword/ChangePassword'
import { AuthPage } from './AuthPage'
import { Profile } from './Profile'
import useAuthObserver from '../hooks/useAuthObserver'
import NotFoundPage from './NotFoundPage'
import TutorialPage from './TutorialPage'
import { getHealth } from '../api/getApi'
import TechnicalWorks from '../components/TechnicalWorks/TechnicalWorks'
import useOnline from '../hooks/useOnline'
import Offline from '../components/Offline/Offline'
import { profilePaths } from '../constants/constants'
import Spinner from '../UI/Spinner/Spinner'
import Unsubscribe from './Unsubscribe'
import useFCMToken from '../hooks/useFCMToken'
import MobStoreRedirect from './MobStoreRedirect'
import UnsubscribeAnonymous from './UnsubscribeAnonymous'
import config from '../constants/config'
import AcceptRejectSeafarer from './AcceptRejectSeafarer'
import DeleteAccountEmail from '../components/Settings/DeleteAccount/DeleteAccountEmail'
import usePageGoogleAnalytics from '../hooks/usePageGoogleAnalytics'

function Root() {
  const [healthcheck, setHealthcheck] = useState({
    status: null,
    message: '',
    downtime: '',
  })

  const { isAuth } = useSelector(({ authentication }) => authentication)
  const { loading } = useSelector(({ user }) => user.profile)

  const dispatch = useDispatch()

  useAuthObserver()
  useFCMToken()
  usePageGoogleAnalytics()

  const isOnline = useOnline()
  const location = useLocation()

  const params = new URLSearchParams(location.search)
  const callbackUrl = params.get('callback_url')

  useEffect(() => {
    const getHealthCheck = async () => {
      setHealthcheck({ ...healthcheck, status: true })

      try {
        const response = await getHealth()

        setHealthcheck({
          ...healthcheck,
          status: true,
          message: response.message,
          downtime: '10 min',
        })
      } catch (error) {
        setHealthcheck({
          ...healthcheck,
          status: false,
          message: error?.response?.data?.message || 'Technical works',
          downtime: error?.response?.data?.downtime || '10 min',
        })
      }
    }

    if (isOnline) getHealthCheck()

    // eslint-disable-next-line
  }, [isOnline])

  useEffect(() => {
    if (isAuth) dispatch(getProfileFetch())

    // eslint-disable-next-line
  }, [isAuth])

  if (!isOnline) return <Offline />
  if (loading) return <Spinner size={90} />

  return (
    <>
      {healthcheck.status === null ? null : healthcheck.status ? (
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              window.location.href = `${config.ROOT_URL}/`
              return null
            }}
          />
          <Route
            exact
            path="/password-reset"
            render={() => {
              window.location.href = `${config.ROOT_URL}/password-reset`
              return null
            }}
          />
          <Route
            exact
            path="/terms"
            render={() => {
              window.location.href = `${config.ROOT_URL}/terms`
              return null
            }}
          />
          <Route
            exact
            path="/privacy"
            render={() => {
              window.location.href = `${config.ROOT_URL}/privacy`
              return null
            }}
          />
          <Route exact path="/tutorial" component={TutorialPage} />
          <Route exact path="/signup-verify" component={SignupVerifyPage} />
          <Route exact path="/change-password" component={ChangePassword} />
          <Route exact path="/delete-account-email" component={DeleteAccountEmail} />
          <Route exact path="/company-unsubscribe" component={Unsubscribe} />
          <Route exact path="/unsubscribe" component={UnsubscribeAnonymous} />
          <Route exact path="/vacancy_request_action" component={AcceptRejectSeafarer} />

          {/* employers pages */}
          <Route path="/auth/">
            {isAuth ? <Redirect to={!callbackUrl ? profilePaths.seafarers_search : callbackUrl} /> : <AuthPage />}
          </Route>
          <Route exact path="/mobile-store-redirect" component={MobStoreRedirect} />
          <Route path="/profile/" component={Profile} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      ) : (
        <TechnicalWorks data={healthcheck} />
      )}
    </>
  )
}

export default Root
